import React, { useEffect, useState } from "react";
import { Checkbox, Divider, Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans, SelectWithSearch, UploadFile, InputDate, InputTime } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { cancelRequestReq, getEmployeeRelatedDataReq, getRelatedDataByReqIdReq, onDateChange, onShiftSelectionChangeReq, updateDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { createSelectList, convertTimeTotz } from '@comps/commonFunctions';
import RoasterView from "@mods/common/RoasterView";
import moment from "moment/moment";
import dayjs from 'dayjs'
import EmployeeInfo from '@mods/common/EmployeeInfo';
import NextApproverInfo from "@mods/common/NextApproverInfo";
const langKey = Const["leaveRequest"].lngKey
const formName = "createLeaveRequest";

var changeShiftPayload = {};
var selectedLeaveType = {};
var selectedEmploymentId = null;
var startTime = null;
var endTime = null;

const getUploadAttachment = (attachment) => {
  if (!attachment) {
    return [];
  }

  return [{
    ...attachment,
    uid: attachment.uid || attachment.id,
    name: attachment.name || attachment.org_name || attachment.file_name,
    status: attachment.status || 'done',
  }];
};

const ViewLeaveRequest = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([])
  const [available, setAvailable] = useState(null)
  const [roasterData, setRoasterData] = useState({})
  const [selectedStart, setStartDateSelected] = useState(dayjs(props.record.end))
  const [selectedEnd, setEndDateSelected] = useState(dayjs(props.record.end))
  const [disabledSave, setDisableSave] = useState(true)
  const [roasterView, setRosterView] = useState(null)
  const [shift_ids, setShiftIds] = useState([]);
  const [isShort, setIsShort] = useState(false)
  const [shortLeaveTypes, setShortLeaveTypes] = useState([])
  const [shortLeaveSelected, setShortLeaveSelected] = useState(null)
  const [hasShort, setHasShort] = useState(false)
  const [preRoster, setPreRoster] = useState({})
  const [leaveRequest, setLeaverequest] = useState();
  const [existingAttachmentId, setExistingAttachmentId] = useState(null);
  const [loading, setloading] = useState(true)
  const [saving, setsaving] = useState(true)
  const [form] = Form.useForm()
  var responseLeaveTypes = {};
  var preSelected = [];

  useEffect(() => {
    //setFormData()
    getEmployeeRelated()
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    const payload = props.record.id
    makeRequest(setLoader, getRelatedDataByReqIdReq, payload, onGetRequestDataSuccess, onGetRequestDataSuccess);
  }
  const onGetRequestDataSuccess = (data, response) => {
    setloading(false)
    setLeaverequest(response.leave_request);
    setFileList(getUploadAttachment(response.leave_request.attachment));
    setExistingAttachmentId(response.leave_request.attachment ? response.leave_request.attachment.id : null);
    preSelected = response.selected;
    if (props.record.is_short) {
      response.leave_request.time_start = convertTimeTotz(response.leave_request.time_start)
      response.leave_request.time_end = convertTimeTotz(response.leave_request.time_end)
      //setStartTime(dayjs(response.leave_request.time_start))
      //setEndTime(dayjs(response.leave_request.time_end))
      startTime = response.leave_request.time_start;
      endTime = response.leave_request.time_end
      setShortLeaveSelected(props.record.short_leave_type_slab_id)
      setShortLeaveTypes([{ label: props.record.short_leave_type_name, value: props.record.short_leave_type_slab_id }])
    }
    response.leave_request.start = dayjs(response.leave_request.start)
    response.leave_request.end = dayjs(response.leave_request.end)
    form.setFieldsValue(response.leave_request)
    form.setFieldsValue({ leave_type_available: response.leave_type_available })
    setAvailable(response.leave_type_available)
    showRoster(response.roster)
    setPreRoster(response.roster)
    setHasShort(props.record.is_short)
    setIsShort(props.record.is_short)
  }

  const getEmployeeRelated = () => {
    const payload = { employment_id: props.record.employment_id }
    makeRequest(setLoader, getEmployeeRelatedDataReq, payload, onGetEmployeeRelated, onError);
  }
  const onGetEmployeeRelated = (data, response) => {
    setLeaveTypes(createSelectList(response.leave_types))
    responseLeaveTypes = response;
  }
  const onSubmit = (data) => {
    if (isShort) {
      data.time_start = dayjs(data.time_start);
      data.time_end = dayjs(data.time_end);
    }
    if (props.action === 'edit') {
      data.start = data.start.format('YYYY-MM-DD');
      data.end = data.end.format('YYYY-MM-DD');
      data.shiftIds = shift_ids.length !== 0 ? shift_ids : getShiftIds(preRoster)
      data.action = props.action
      data.employment_id = props.record.employment_id
      data.id = props.record.id
      const fileAttachment = fileList.length > 0 && fileList[0].id === undefined ? fileList[0].originFileObj : null;
      data.remove_attachment = existingAttachmentId && fileList.length === 0 ? true : false;
      delete data.file_attachment;
      const payload = { filters: props.filters, file_attachment: fileAttachment, leave_request: data };
      makeRequest(setLoader, updateDataReq, payload, onSuccess, onError);
    }
    if (props.action === 'cancel') {
      const payload = { cancel_request: { employment_id: props.record.employment_id, requestable_class: 'leave_request', requestable_id: leaveRequest.id, description: data.description } }
      makeRequest(setLoader, cancelRequestReq, payload, onSuccess, onError);
    }
    setSaveLoader(true)
    setsaving(true)
  }

  const onSuccess = (data, res) => {
    setsaving(false)
    setSaveLoader(false)
    if (data.cancel_requests) {
      props.getAllData();
    }
    else {
      props.onCompleted(data.leave_requests.data);
    }
    props.onCompleted(data);
    message.success("Record Saved successfully");
  }

  const onError = (err, res) => {
    setsaving(false)
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  const onChangeLeaveType = (e) => {
    responseLeaveTypes['leave_types'].map((each) => {
      if (each.id === e) {
        selectedLeaveType = each;
        setShortLeaveTypes(createSelectList(each.short_leave_type_slabs))
        form.setFieldsValue({ leave_type_available: each.available })
        setAvailable(each.available)
        setHasShort(each.short_leave_type_slabs.length ? true : false)
      }
    })
    //form.setFieldsValue({ leave_type_available: responseLeaveTypes.leave_types[0].available })
  }
  const onChangeShortLeaveType = (id) => {
    setShortLeaveSelected(id)
    onChangeStartDate(selectedStart)
  }
  const onChangeTime = (start, type) => {

    if (start) {
      const end = convertTimeTotz(endTime);
      const differenceInHours = end.diff(start, 'hour') + 1;
      const count = form.getFieldValue('shift_count');
      const duration = count * differenceInHours;
      form.setFieldsValue({
        time_start: start,
        time_end: start.add(duration, 'hour'),
      })
    } else {
      form.setFieldsValue({
        time_start: null,
        time_end: null,
      })
    }
  }
  const onChangeStartDate = (date) => {
    if (!date) {
      form.setFieldsValue({
        time_start: null, time_end: null, count: null,
        shift_count: null,
        sandwich_count: null,
      })
      setRosterView(null);
    }
    setStartDateSelected(date)

    let end_date = form.getFieldValue('end');
    let end = end_date;
    if (!end_date || isShort) {
      form.setFieldsValue({ end: date })
      end = date;
    }
    if (date) {
      let payload = {
        leave_request: {
          is_short: form.getFieldValue('is_short'),
          start: date.format('YYYY-MM-DD'),
          end: end ? end.format('YYYY-MM-DD') : date.format('YYYY-MM-DD'),
          time_start: startTime,
          time_end: endTime,
          employment_id: props.record.employment_id,
          leave_type_id: form.getFieldValue('leave_type_id'),
          short_leave_type_slab_id: isShort ? form.getFieldValue('short_leave_type_slab_id') : null,
          leave_type_available: selectedLeaveType.available,
          action: props.action
        }
      }
      changeShiftPayload = payload;
      makeRequest(setLoader, onDateChange, payload, onSuccessDateChange, onDatechangeError);
    }
  }

  const onChangeEndDate = (e) => {
    setEndDateSelected(e)

    let start_date = form.getFieldValue('start');
    if (!start_date) {
      form.setFieldsValue({ start: e })
    }
    if (e) {
      let payload = {
        leave_request: {
          is_short: selectedLeaveType.is_short,
          start: start_date ? start_date.format('YYYY-MM-DD') : e.format('YYYY-MM-DD'),
          end: e.format('YYYY-MM-DD'),
          start_time: null,
          end_time: null,
          employment_id: props.record.employment_id,
          leave_type_id: selectedLeaveType.leave_type_id ? selectedLeaveType.leave_type_id : form.getFieldValue('leave_type_id'),
          leave_type_available: available,
          action: props.action
        }
      }
      changeShiftPayload = payload;
      makeRequest(setLoader, onDateChange, payload, onSuccessDateChange, onDatechangeError);
    }

  }

  const onSuccessDateChange = (response, data) => {

  }
  const onDatechangeError = (response, data) => {

    if (data.response) {
      form.setFieldsValue({
        count: null,
        shift_count: null,
        sandwich_count: null
      })
      message.error(data.response.data.message)
      return
    }

    if (data.shifts) {
      setDisableSave(false)
    }

    showRoster(data)
    setRoasterData(data)
    onShiftChange(data)
  }
  const showRoster = (data) => {
    setRosterView(<RoasterView record={ data } preSelected={ preSelected } disabled={ props.disabled } />)
  }
  const onShiftChange = (data) => {
    //get shiftIds
    let shiftIds = getShiftIds(data);
    changeShiftPayload.leave_request.shiftIds = shiftIds
    changeShiftPayload.leave_request.action = props.action
    let payload = changeShiftPayload
    makeRequest(setLoader, onShiftSelectionChangeReq, payload, onSuccessShiftChange, onShiftchangeError);
  }

  const getShiftIds = (data) => {

    let shiftIds = [];
    let date_total = [];
    let start = moment(new Date(data.from_date))
    let end = moment(new Date(data.to_date))
    if (start === end) {
      date_total.push(start)
      //setDateTotalSource(date_total)
    }
    else {
      while (start <= end) {
        date_total.push(start.format('YYYYMMDD'));
        start = start.add(1, 'days');
      }
    }
    date_total.map((date) => (
      data.employments.map((employee) => {
        if (data.shifts.hasOwnProperty(date + '-' + employee.id)) {
          shiftIds.push(data.shifts[date + '-' + employee.id][0]['id'])
          let start = data.shifts[date + '-' + employee.id][0].start
          let end = data.shifts[date + '-' + employee.id][0].end
          startTime = start;
          endTime = end;
        }
      })
    ))
    setShiftIds(shiftIds)
    return shiftIds;
  }
  const onSuccessShiftChange = (response, data) => {

  }
  const onShiftchangeError = (response, data) => {

    if (data.response) {
      form.setFieldsValue({
        count: null,
        shift_count: null,
        sandwich_count: null
      })
      message.error(data.response.data.message)
      return
    }
    let start, end, duration;
    start = startTime ? convertTimeTotz(startTime) : null;
    end = endTime ? convertTimeTotz(endTime) : null;
    if (start && end) {
      // Calculate the difference in hours
      const differenceInHours = end.diff(start, 'hour');
      duration = data.shift_count * differenceInHours;
    }

    form.setFieldsValue({
      time_start: start,
      time_end: endTime ? start.add(duration, 'hour') : null,
      shift_count: data.shift_count,
      sandwich_count: data.sandwich_count,
      count: data.count
    })
  }
  //-----------------------
  //============uploading file Attachment============
  const [fileList, setFileList] = useState([]);
  // ------------------------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    !props.disabled &&
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" disabled={ props.action === 'view' ? true : false } />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1200 } maskClosable={ false }
      mainTitle={ props.disabled ? trans(Commons.view) : trans(Commons.update) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <EmployeeInfo record={ props.record.requestor && props.record.requestor } />
        { leaveRequest && !leaveRequest.is_completed && <NextApproverInfo approver={ leaveRequest.next_requestee_name } /> }
        <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } disabled={ props.disabled } scrollToFirstError>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="leave_type_id" rules={ rules.leave_type_id } label={ trans(`${langKey}.leave_type_id`) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ leaveTypes }
                  placeholder={ trans(`${langKey}.leave_type_id`) }
                  onChange={ onChangeLeaveType }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="leave_type_available" rules={ rules.current_available } label={ trans(`${langKey}.current_available`) }
                className="da-mb-16"
                { ...getErrorProps(errors['current_available']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.current_available`) } type="number" onWheel={ (e) => e.target.blur() } disabled />
              </Form.Item>
            </Col>
            { hasShort ?
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="is_short" rules={ rules.is_short } label={ trans(`${langKey}.is_short`) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['is_short']) } size="small"
                  valuePropName="checked"
                >
                  <Checkbox onChange={ (e) => setIsShort(e.target.checked) } />
                </Form.Item>
              </Col>
              : '' }

            {
              isShort ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="short_leave_type_slab_id" rules={ rules.short_leave_type_slab_id } label={ trans(`${langKey}.short_leave_type_slab_id`) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['name']) } size="small"
                  >
                    <SelectWithSearch
                      options={ shortLeaveTypes }
                      placeholder={ trans(`${langKey}.short_leave_type_slab_id`) }
                      onChange={ onChangeShortLeaveType }
                    />
                  </Form.Item>
                </Col>
                : ''
            }

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="start" rules={ rules.start } label={ trans(`${langKey}.start`) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputDate onChange={ (date) => onChangeStartDate(date) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="end" rules={ rules.end } label={ trans(`${langKey}.end`) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputDate onChange={ (date) => onChangeEndDate(date) } disabled={ isShort } />
              </Form.Item>
            </Col>
          </Row>
          { roasterView }

          <Row gutter={ 30 }>
            { isShort ?
              <>
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="time_start" rules={ rules.time_start } label={ trans(`${langKey}.time_start`) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['name']) } size="small"
                  >
                    <InputTime placeholder={ trans(`${langKey}.time_start`) } onChange={ (time) => onChangeTime(time, 'time_start') } />
                  </Form.Item>
                </Col>

                <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                  <Form.Item name="time_end" rules={ rules.time_end } label={ trans(`${langKey}.time_end`) }
                    className="da-mb-16"
                    { ...getErrorProps(errors['name']) } size="small"
                  >
                    <InputTime placeholder={ trans(`${langKey}.time_end`) } disabled={ isShort } />
                  </Form.Item>
                </Col>
              </>
              : ''
            }
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="shift_count" rules={ rules.shift_count } label={ trans(`${langKey}.shift_count`) }
                className="da-mb-16"
                { ...getErrorProps(errors['shift_count']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.shift_count`) } type="number" onWheel={ (e) => e.target.blur() } value={ available } disabled={ true } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="sandwich_count" rules={ rules.sandwich_count } label={ trans(`${langKey}.sandwich_count`) }
                className="da-mb-16"
                { ...getErrorProps(errors['sandwich_count']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.sandwich_count`) } type="number" onWheel={ (e) => e.target.blur() } value={ available } disabled={ true } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="count" rules={ rules.count } label={ trans(`${langKey}.count`) }
                className="da-mb-16"
                { ...getErrorProps(errors['count']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.count`) } type="number" onWheel={ (e) => e.target.blur() } value={ available } disabled={ true } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="reason" rules={ rules.reason } label={ trans(`${langKey}.reason`) }
                className="da-mb-16"
                { ...getErrorProps(errors['reason']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.reason`) } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item label={ trans(`${langKey}.attachment`) } name="file_attachment" >
                <UploadFile fileList={ fileList } setFileList={ setFileList } />
              </Form.Item>
            </Col>
          </Row>


          { props.action === 'cancel' ?
            <>
              <Divider>Cancelation</Divider>
              <Form.Item name="description" rules={ rules.reason } label={ trans(`${langKey}.reason`) }
                className="da-mb-16"
                { ...getErrorProps(errors['reason']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.description`) } disabled={ false } />
              </Form.Item>
            </>
            : ''
          }

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default ViewLeaveRequest

const rules = {
  leave_type_id: [
    { required: true, message: trans(`${langKey}.leave_type_id`) },
  ],
  start: [
    { required: true, message: trans(`${langKey}.start`) },
  ],
  end: [
    { required: true, message: trans(`${langKey}.end`) },
  ],
  time_start: [
    { required: true, message: trans(`${langKey}.time_start`) },
  ],
  time_end: [
    { required: true, message: trans(`${langKey}.time_end`) },
  ],
  count: [
    { required: true, message: trans(`${langKey}.count`) },
  ],
  shift_count: [
    { required: true, message: trans(`${langKey}.shift_count`) },
  ],
  reason: [
    { required: true, message: trans(`${langKey}.reason`) },
  ],
  short_leave_type_slab_id: [
    { required: true, message: trans(`${langKey}.short_leave_type_slab_id`) },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
